// Thanh lọc nhanh của tab Thống kê: Hôm nay / 7 ngày / 30 ngày / Tuỳ chọn + làm mới + xuất CSV.
import { Button, DatePicker, Segmented, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faFileCsv } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";

export const PRESETS = [
    { value: "today", label: "Hôm nay", days: 1 },
    { value: "7", label: "7 ngày", days: 7 },
    { value: "30", label: "30 ngày", days: 30 },
    { value: "custom", label: "Tuỳ chọn" },
];
export const MAX_DAYS = 62;

export const rangeOfPreset = (value) => {
    const days = PRESETS.find((p) => p.value === value)?.days || 7;
    return [dayjs().subtract(days - 1, "day"), dayjs()];
};

export default function XuStatsToolbar({ preset, onPreset, range, onRange, onRefresh, onExport, loading, canExport }) {
    return (
        <div className="flex flex-wrap items-center gap-2">
            <Segmented value={preset} onChange={onPreset} options={PRESETS.map(({ value, label }) => ({ value, label }))} />
            <DatePicker.RangePicker
                value={range}
                allowClear={false}
                format="DD/MM/YYYY"
                disabledDate={(d) => d.isAfter(dayjs(), "day")}
                onChange={(v) => {
                    if (!v) return;
                    if (v[1].diff(v[0], "day") >= MAX_DAYS) return message.warning(`Chỉ xem tối đa ${MAX_DAYS} ngày`);
                    onRange(v);
                }}
            />
            <div className="flex gap-2 ml-auto">
                <Button icon={<FontAwesomeIcon icon={faArrowsRotate} />} onClick={onRefresh} loading={loading}>Làm mới</Button>
                <Button icon={<FontAwesomeIcon icon={faFileCsv} />} onClick={onExport} disabled={!canExport}>Xuất CSV</Button>
            </div>
        </div>
    );
}
